"use client";

import { useState, useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function CallToAction() {
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!sectionRef.current) return;
      const rect = sectionRef.current.getBoundingClientRect();
      const x = (e.clientX - rect.left - rect.width / 2) / rect.width;
      const y = (e.clientY - rect.top - rect.height / 2) / rect.height;
      setMousePosition({
        x,
        y
      });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);
  return <section id="call-to-action" ref={sectionRef} className="relative min-h-[70vh] flex items-center justify-center overflow-hidden bg-background py-24">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542870/img/organic_wood_grain_texture.png)] bg-cover bg-center opacity-10 transition-transform duration-300 ease-out" style={{
      transform: `translate(${-mousePosition.x * 20}px, ${-mousePosition.y * 20}px)`
    }} />

      {}
      <div className="relative z-10 text-center px-6 max-w-3xl mx-auto">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-foreground mb-6 leading-tight">
          Ready to Give Your Pets the Best Care?
        </h2>
        <p className="text-lg md:text-xl text-muted-foreground mb-12 max-w-2xl mx-auto">
          Experience our state-of-the-art facilities and meet our dedicated team. Book your visit today.
        </p>

        {}
        <div className="relative inline-block">
          <Link to="#" newTab={false}>
            <Button size="lg" className="relative overflow-hidden bg-accent text-foreground-accent px-12 py-6 text-lg font-semibold rounded-md shadow-medium hover:shadow-strong hover:scale-105 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] focus-visible:ring-2 focus-visible:ring-accent/50 before:absolute before:inset-0 before:bg-gradient-to-r before:from-transparent before:via-white/20 before:to-transparent before:translate-x-[-200%] before:animate-[shimmer_3s_ease-in-out_infinite] before:pointer-events-none">
              Schedule a Visit
            </Button>
          </Link>
        </div>
      </div>

      <style jsx>{`
        @keyframes shimmer {
          0%,
          100% {
            transform: translateX(-200%);
          }
          50% {
            transform: translateX(200%);
          }
        }
      `}</style>
    </section>;
}